import { useState, useEffect } from 'react';

export function useLoaded() {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		setLoaded(true);
	}, []);

	return loaded;
}
